// extracted by mini-css-extract-plugin
export default {"container":"home_container__3CYjX","carousel":"home_carousel__gV8mv","projectron":"home_projectron__3HQSE"};